import React, { Component } from 'react';
import { Player } from 'video-react';
import "../../../../node_modules/video-react/dist/video-react.css"; // import css
import PropTypes from 'prop-types';

class VideoItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            imageId: ''

        };

    }


    componentDidMount() {
        /*this.props.getGalleryInfo();
        let imgIndex = this.props.galleryInfo.imgIndex;
        this.setState({'imgIndex' : imgIndex});*/
    }

    render() {
        let image = this.props.item;
    //    let itemIndex = this.props.iteration;
        // let imgpath = IMGIX_PATH +'assets/slider/'+ image.img_name+'?fit=crop&h=500&w=800&auto=enhance&dpr=3%203x';

        let videoPath = image.img_path;
        let defImgSrc = require("../../../assets/images/no-image.jpg");
        /*let im_class = "carousel-item ";


        console.log("itemIndex"+itemIndex);

        if(itemIndex == this.state.imgIndex ) {
            im_class += "active";
        }*/
        let elId = "video"+this.props.iteration;


        return (

            <div className="carousel-item "  id={elId}>
                <Player
                    playsInline
                    poster= {defImgSrc}
                    src= {videoPath}
                    width="100%"
                    height={450}
                    fluid = {false}
                />
            </div>
        );
    }


}

VideoItem.propTypes = {
    iteration: PropTypes.number
}

/*function mapStateToProps(state) {

    return {
        galleryInfo  :galleryReducers.setGalleryUpdate(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    getGalleryInfo : galleryActions.getImgId
})(ImageItem));*/

export default VideoItem;




// WEBPACK FOOTER //
// ./src/components/includes/Slider/VideoItem.js